
import { computed, ref, defineComponent, reactive } from 'vue'
import { useRouter } from 'vue-router'
import ArchiveBanner from '@/components/block/ArchiveBanner.vue'
import EventFooter from '@/components/block/EventFooter.vue'
import EventPresent from '@/components/block/EventPresent.vue'
import Button from '@/components/elements/Button.vue'
import FaqLists from '@/components/block/FaqLists.vue'
import Alert from '@/components/elements/Alert.vue'
import AdBanner, { AdBannerType } from '@/components/block/AdBanner.vue'
import { axiosSetting } from '@/utils/axiosSetting'
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import InputSelectbox from '@/components/elements/InputSelectbox.vue'
import EventCardActive from '@/components/block/EventCardActive.vue'
import LocalNav from '@/components/block/LocalNav.vue'

import { useEvent } from '@/provider/event'
import { mapValues, omitBy } from 'lodash-es'
import dayjs from 'dayjs'
import 'dayjs/locale/ja'
dayjs.locale('ja')
export default defineComponent({
  name: 'EventsList',
  components: {
    HeadingLv2,
    ArchiveBanner,
    EventPresent,
    EventFooter,
    Button,
    FaqLists,
    Alert,
    AdBanner,
    HeadingLv1,
    HeadingLv3,
    EventCardActive,
    LocalNav,
    InputSelectbox
  },
  setup() {
    const router = useRouter()
    const ajax = axiosSetting('cms', 'block')

    const {
      getEvents,
      eventsByMonth: eventsByMonthBase,
      createCategories,
      createFilterType
    } = useEvent()
    getEvents()

    const filteredCategory = ref<any>(undefined)
    const filterCategory = (value: string) => {
      console.log(value)
      filteredCategory.value = value
    }
    const selectedFilterType = ref<any>(undefined)
    const selectFilterType = (val: string | null | undefined) => {
      selectedFilterType.value = val
    }
    const eventsByMonth = computed(() =>
      omitBy(
        mapValues(eventsByMonthBase.value, (events) =>
          events.filter((event: any) => {
            if (
              filteredCategory.value &&
              event.category?.slug !== filteredCategory.value
            ) {
              return false
            }
            if (selectedFilterType.value && !event.filter_type.length) {
              return false
            }
            if (
              selectedFilterType.value &&
              event.filter_type.every(
                (type: any) => type.value !== selectedFilterType.value
              )
            ) {
              return false
            }
            return true
          })
        ),
        (events: any) => !events.length
      )
    )

    const navList = computed(() =>
      Object.keys(eventsByMonth.value).map((YYYYMM) => ({
        id: YYYYMM,
        label: dayjs(`${YYYYMM}01`).format('YYYY年M月')
      }))
    )
    const categories = computed(() =>
      createCategories(Object.values(eventsByMonthBase.value).flat())
    )
    const filterTypes = computed(() =>
      createFilterType(Object.values(eventsByMonthBase.value).flat())
    )

    // FAQ
    const toFaq = () => {
      router.push({ path: '/faq' })
    }
    const faqs = ref([])
    const getFaqs = () => {
      ajax
        .get(
          `${process.env.VUE_APP_WPAPI_URL}wp-json/wp/v2/faq?category=events&per_page=5`
        )
        .then((res) => {
          faqs.value = res.data
        })
    }
    getFaqs()

    // 有料バナー表示病院を取得
    const adBanners = reactive<AdBannerType[]>([])
    const ajaxApp = axiosSetting('app', 'block')

    ajaxApp.get('/api/v1/banner?opt_id=4').then((res) => {
      if (res.data.length === 0) return

      const ads = res.data
      let count = 0
      const indexArr: Array<number> = []
      const maxCount = ads.length < 2 ? ads.length : 2

      while (count < maxCount) {
        const randomIndex: number = Math.floor(Math.random() * ads.length)

        if (!indexArr.includes(randomIndex)) {
          indexArr.push(randomIndex)
          count++
        }
      }
      for (let i = 0; i < indexArr.length; i++) {
        adBanners.push(ads[indexArr[i]])
      }
    })

    return {
      toFaq,
      faqs,
      adBanners,
      eventsByMonth,
      navList,
      categories,
      filterCategory,
      filterTypes,
      selectFilterType
    }
  }
})
